import { render } from "./headings3Page.vue?vue&type=template&id=551d891c"
import script from "./headings3Page.vue?vue&type=script&lang=js"
export * from "./headings3Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__